import { render } from "./QuanLyDonHangSales.vue?vue&type=template&id=60724276&scoped=true"
import script from "./QuanLyDonHangSales.vue?vue&type=script&lang=js"
export * from "./QuanLyDonHangSales.vue?vue&type=script&lang=js"

import "./QuanLyDonHangSales.vue?vue&type=style&index=0&id=60724276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60724276"]])

export default __exports__